import React from 'react';
import { InView } from 'react-intersection-observer';
import Image from './Image';
import { ImageContainer } from './PlayImage.styles';

type InViewWrapperProps = {
    ssr: boolean;
    children: ({ inView: boolean, ref: any }) => JSX.Element;
};

const InViewWrapper = ({ ssr, children }: InViewWrapperProps): JSX.Element => {
    if (ssr) {
        return children({ inView: true, ref: null });
    }

    return (
        <InView rootMargin="200px 0px" triggerOnce>
            {children}
        </InView>
    );
};

export enum ImageRatio {
    SIXTEEN_BY_NINE = '16-9',
    CINEMA = 'cinema',
    SQUARE = 'square',
    IMAX = 'imax',
    TWO_BY_THREE = '2-3',
}

type Props = {
    src?: string;
    alt: string;
    srcSet?: string;
    sizes?: string;
    height?: number;
    width?: number;
    imageRatio?: ImageRatio;
    ssr?: boolean;
    children?: JSX.Element | JSX.Element[];
    blurred?: boolean;
    opacity?: number;
    showPlaceholder?: boolean;
    className?: string;
};

const PlayImage = ({
    src,
    srcSet,
    sizes,
    alt = '',
    height,
    width,
    imageRatio = ImageRatio.SIXTEEN_BY_NINE,
    ssr,
    children,
    blurred,
    opacity,
    showPlaceholder,
    className,
}: Props): JSX.Element => (
    <InViewWrapper ssr={ssr}>
        {({ inView, ref }) => (
            <ImageContainer
                imageRatio={imageRatio}
                ref={ref}
                className={className}
                useOpacity={typeof opacity === 'number'}
            >
                <Image
                    key={src}
                    width={width}
                    height={height}
                    data-src={src}
                    src={src}
                    srcSet={srcSet}
                    sizes={sizes}
                    alt={alt}
                    inView={inView}
                    blurred={blurred}
                    showPlaceholder={showPlaceholder}
                    opacity={opacity}
                    ssr={ssr}
                />
                {children}
            </ImageContainer>
        )}
    </InViewWrapper>
);

export default PlayImage;
